import React, { useState, useEffect } from 'react'

const MIN_VOLTAGE = 207
const MAX_VOLTAGE = 253

const MeterDiagram = ({ valueMet }) => {
  const [diagramData, setDiagramData] = useState(null)
  // const [diagram, setDiagram] = useState({y1: 0, x2: 0,
  //   y2: 0, 
  //   x3: 0, 
  //   y3: 0, 
  //   pivot1_3: 0, 
  //   pivot3_2: 0, 
  //   pivot2_1: 0, 
  //   middle1_3: 0, 
  //   middle3_2: 0,
  //   middle2_1: 0})

  // const haseMaxVoltage = () => {
  //     return Math.max(
  //         valueMet.A_PHA_VOLT_FL_1,
  //         valueMet.B_PHA_VOLT_FL_1,
  //         valueMet.C_PHA_VOLT_FL_1,
  //     )
  //   }

  useEffect(() => {
    let mounted = true

    if (valueMet) {
      setDiagramData(valueMet)

      // console.log({ valueMet })
      // setDiagram({y1:
      //       parseFloat(valueMet.A_PHA_VOLT_FL_1) < MIN_VOLTAGE
      //         ? 64.6 + (16.4 / 206) * -parseFloat(valueMet.A_PHA_VOLT_FL_1)
      //         : parseFloat(valueMet.A_PHA_VOLT_FL_1) < MAX_VOLTAGE
      //           ? 48.2 + (17.3 / 47) * -(parseFloat(valueMet.A_PHA_VOLT_FL_1) - 206)
      //           : 30.9 + (11.5 / 17) * -(parseFloat(valueMet.A_PHA_VOLT_FL_1) - 253),

      //     x2:
      //       parseFloat(valueMet.B_PHA_VOLT_FL_1) < MIN_VOLTAGE
      //         ? 47.6 + (14 / 206) * parseFloat(valueMet.B_PHA_VOLT_FL_1)
      //         : parseFloat(valueMet.B_PHA_VOLT_FL_1) < MAX_VOLTAGE
      //           ? 61.6 + (15.1 / 47) * (parseFloat(valueMet.B_PHA_VOLT_FL_1) - 206)
      //           : 76.7 + (9.9 / 17) * (parseFloat(valueMet.B_PHA_VOLT_FL_1) - 253),
      //     y2: 0.5681 * x2 + 39.6,

      //     x3:
      //       parseFloat(valueMet.C_PHA_VOLT_FL_1) < MIN_VOLTAGE
      //         ? 45.2 + (14.4 / 206) * -parseFloat(valueMet.C_PHA_VOLT_FL_1)
      //         : parseFloat(valueMet.C_PHA_VOLT_FL_1) < MAX_VOLTAGE
      //           ? 30.8 + (15.2 / 47) * -(parseFloat(valueMet.C_PHA_VOLT_FL_1) - 206)
      //           : 15.6 + (9.8 / 17) * -(parseFloat(valueMet.C_PHA_VOLT_FL_1) - 253),
      //     y3: -0.5612 * x3 + 91.9,

      //     pivot1_3: ((Math.atan2(y1 - y3, x1 - x3) * 180) / Math.PI).toString(),
      //     pivot3_2: (
      //       (Math.atan2(y3 - y2, x3 - x2) * 180) / Math.PI +
      //       180
      //     ).toString(),
      //     pivot2_1: ((Math.atan2(y2 - y1, x2 - x1) * 180) / Math.PI).toString(),

      //     middle1_3: {
      //       x: (x1 + x3) / 2,
      //       y: (y1 + y3) / 2,
      //     },
      //     middle3_2: {
      //       x: (x3 + x2) / 2,
      //       y: (y3 + y2) / 2,
      //     },
      //     middle2_1: {
      //       x: (x2 + x1) / 2,
      //       y: (y2 + y1) / 2,
      //     }})
    }
    return () => {
      mounted = false
    }
  }, [valueMet])


  const x1 = 46.18
  let y1 =
    parseFloat(valueMet.A_PHA_VOLT_FL_1) < MIN_VOLTAGE
      ? 64.6 + (16.4 / 206) * -parseFloat(valueMet.A_PHA_VOLT_FL_1)
      : parseFloat(valueMet.A_PHA_VOLT_FL_1) < MAX_VOLTAGE
        ? 48.2 + (17.3 / 47) * -(parseFloat(valueMet.A_PHA_VOLT_FL_1) - 206)
        : 30.9 + (11.5 / 17) * -(parseFloat(valueMet.A_PHA_VOLT_FL_1) - 253)

  let x2 =
    parseFloat(valueMet.B_PHA_VOLT_FL_1) < MIN_VOLTAGE
      ? 47.6 + (14 / 206) * parseFloat(valueMet.B_PHA_VOLT_FL_1)
      : parseFloat(valueMet.B_PHA_VOLT_FL_1) < MAX_VOLTAGE
        ? 61.6 + (15.1 / 47) * (parseFloat(valueMet.B_PHA_VOLT_FL_1) - 206)
        : 76.7 + (9.9 / 17) * (parseFloat(valueMet.B_PHA_VOLT_FL_1) - 253)
  let y2 = 0.5681 * x2 + 39.6

  let x3 =
    parseFloat(valueMet.C_PHA_VOLT_FL_1) < MIN_VOLTAGE
      ? 45.2 + (14.4 / 206) * -parseFloat(valueMet.C_PHA_VOLT_FL_1)
      : parseFloat(valueMet.C_PHA_VOLT_FL_1) < MAX_VOLTAGE
        ? 30.8 + (15.2 / 47) * -(parseFloat(valueMet.C_PHA_VOLT_FL_1) - 206)
        : 15.6 + (9.8 / 17) * -(parseFloat(valueMet.C_PHA_VOLT_FL_1) - 253)
  let y3 = -0.5612 * x3 + 91.9

  let pivot1_3 = ((Math.atan2(y1 - y3, x1 - x3) * 180) / Math.PI).toString()
  let pivot3_2 = (
    (Math.atan2(y3 - y2, x3 - x2) * 180) / Math.PI +
    180
  ).toString()
  let pivot2_1 = ((Math.atan2(y2 - y1, x2 - x1) * 180) / Math.PI).toString()

  let middle1_3 = {
    x: (x1 + x3) / 2,
    y: (y1 + y3) / 2,
  }
  let middle3_2 = {
    x: (x3 + x2) / 2,
    y: (y3 + y2) / 2,
  }
  let middle2_1 = {
    x: (x2 + x1) / 2,
    y: (y2 + y1) / 2,
  }

  return (
    <React.Fragment>
      {valueMet && diagramData ? <svg
        //   width={compWidth}
        //   height={compHeight}
        style={{
          marginLeft: 13,
        }}
        viewBox="0 0 95.22 133.89"
      >
        <g
          style={{
            isolation: 'isolate',
            opacity: 0.7,
          }}>
          <path
            d="M76.46 48.17C70.51 38.03 59.6 31.13 47.09 30.82c-.3-.02-.61-.02-.9-.02-19.36 0-35.11 15.75-35.11 35.11s15.75 35.11 35.11 35.11S81.3 85.27 81.3 65.91c0-6.47-1.76-12.54-4.83-17.74ZM46.18 83.72c-9.82 0-17.8-7.99-17.8-17.8s7.99-17.8 17.8-17.8c.11 0 .22 0 .33.01.38 0 .75.01 1.12.05 9.14.74 16.34 8.42 16.34 17.74 0 9.82-7.99 17.8-17.8 17.8Z"
            style={{
              fill: '#105a2e',
              strokeWidth: 0,
            }}
          />
        </g>
        <polygon
          points={`${x3},${y3} ${x2},${y2} 46.18,${y1}`}
          style={{ fill: 'none', stroke: 'white', strokeWidth: 0.4 }}
        />
        <path
          d="m4.39 89.4 41.79-23.49V18.07M87.97 89.4 46.18 65.91"
          style={{
            fill: 'none',
            stroke: '#16703a',
            strokeMiterlimit: 10,
            strokeWidth: '.4px',
          }}
        />
        <circle
          cx={x2}
          cy={y2}
          r={1.11}
          data-name="napiecie L2"
          style={{
            fill:
              parseFloat(valueMet.B_PHA_VOLT_FL_1) >= MIN_VOLTAGE && parseFloat(valueMet.B_PHA_VOLT_FL_1) < MAX_VOLTAGE ? 'white' : 'red',
            strokeWidth: 0,
          }}
        />
        <circle
          cx={x3}
          cy={y3}
          r={1.11}
          data-name="napiecie L3"
          style={{
            fill:
              parseFloat(valueMet.C_PHA_VOLT_FL_1) >= MIN_VOLTAGE && parseFloat(valueMet.C_PHA_VOLT_FL_1) < MAX_VOLTAGE ? 'white' : 'red',
            strokeWidth: 0,
          }}
        />
        {/* <Path
            d="M46.51 48.12c.38 0 .75.01 1.12.05h-1.12z"
            style={{
              fill: '#105a2e',
              isolation: 'isolate',
              opacity: 0.5,
              strokeWidth: 0,
            }}
          /> */}

        <rect
          width={21.12}
          height={5.89}
          x={68}
          y={0.05}
          rx={1.25}
          ry={1.25}
          style={{
            fill: '#105a2e',
            opacity: 0.5,
            stroke: '#26bf64',
            strokeMiterlimit: 10,
            strokeWidth: '.3px',
          }}
        />
        <rect
          width={21.12}
          height={5.89}
          x={68}
          y={17.36}
          rx={1.25}
          ry={1.25}
          style={{
            fill: '#105a2e',
            opacity: 0.5,
            stroke: '#26bf64',
            strokeMiterlimit: 10,
            strokeWidth: '.3px',
          }}
        />
        {/* <Path
            d="M76.01 2.77c0-.19 0-.34-.01-.49h.29l.02.29h.01c.1-.17.27-.33.56-.33.25 0 .43.15.51.36.06-.1.13-.18.2-.23.11-.08.23-.13.4-.13.24 0 .59.16.59.78v1.06h-.32V3.06c0-.34-.13-.55-.39-.55-.19 0-.33.14-.39.3-.01.04-.03.1-.03.16v1.11h-.32V3c0-.29-.13-.49-.38-.49-.2 0-.35.16-.4.33-.02.05-.03.1-.03.16v1.08H76V2.77ZM80.1 4.08l-.03-.23h-.01c-.1.14-.29.27-.55.27-.36 0-.55-.26-.55-.52 0-.43.39-.67 1.08-.67v-.04c0-.15-.04-.42-.41-.42-.17 0-.34.05-.47.13l-.07-.21c.15-.1.36-.16.59-.16.55 0 .68.37.68.73v.67c0 .16 0 .31.03.43h-.3Zm-.05-.91c-.36 0-.76.06-.76.4 0 .21.14.31.31.31a.445.445 0 0 0 .45-.4zM81.05 2.29l.26.39c.07.1.12.19.18.29h.01c.06-.11.12-.2.18-.3l.25-.38h.35l-.61.87.63.93h-.37l-.26-.4c-.07-.1-.13-.2-.19-.31-.06.11-.12.2-.19.31l-.26.4h-.36l.64-.92-.61-.88h.36ZM83.29 4.08v-.2l.26-.25c.62-.59.89-.9.9-1.26 0-.24-.12-.47-.48-.47-.22 0-.4.11-.51.2l-.1-.23c.17-.14.4-.24.68-.24.52 0 .74.36.74.7 0 .44-.32.8-.83 1.29l-.19.18h1.08v.27H83.3ZM86.63 1.95h-.92l-.09.62c.05 0 .11-.01.2-.01.19 0 .37.04.52.13.19.11.34.31.34.62 0 .47-.37.82-.9.82-.26 0-.49-.07-.6-.15l.08-.25c.1.06.3.13.52.13.31 0 .57-.2.57-.52 0-.31-.21-.53-.69-.53-.14 0-.24.02-.33.03l.16-1.16h1.15v.27ZM87.18 3.71c.09.06.31.15.53.15.42 0 .55-.27.54-.47 0-.34-.31-.48-.62-.48h-.18v-.24h.18c.24 0 .54-.12.54-.41 0-.19-.12-.36-.42-.36-.19 0-.38.08-.48.16l-.09-.24c.13-.09.37-.19.63-.19.47 0 .69.28.69.57 0 .25-.15.46-.45.57.3.07.54.29.54.63 0 .39-.3.72-.88.72-.27 0-.51-.09-.63-.16l.09-.25ZM90.32 4.08l-.82-2.5h.35l.39 1.23c.11.34.2.64.27.93.07-.29.17-.6.29-.93l.42-1.23h.34l-.89 2.5h-.36ZM38.49 12.18c0-.19 0-.34-.01-.49h.29l.02.3c.09-.17.3-.34.59-.34.25 0 .63.15.63.76v1.07h-.33v-1.03c0-.29-.11-.53-.42-.53-.21 0-.38.15-.44.33a.68.68 0 0 0-.02.15v1.08h-.33v-1.31ZM41.54 13.49l-.03-.23h-.01c-.1.14-.29.27-.55.27-.36 0-.55-.26-.55-.52 0-.43.39-.67 1.08-.67v-.04c0-.15-.04-.42-.41-.42-.17 0-.34.05-.47.13l-.07-.21c.15-.1.36-.16.59-.16.55 0 .68.37.68.73v.67c0 .16 0 .31.03.43h-.3Zm-.05-.91c-.36 0-.76.06-.76.4 0 .21.14.31.31.31a.445.445 0 0 0 .45-.4zM42.33 12.28c0-.23 0-.42-.01-.59h.29V12h.02c.13-.22.34-.35.64-.35.43 0 .76.37.76.91 0 .65-.39.96-.82.96-.24 0-.45-.1-.55-.28v.98h-.32v-1.94Zm.33.48s0 .09.01.13c.06.23.26.38.49.38.34 0 .54-.28.54-.69 0-.36-.19-.67-.53-.67-.22 0-.43.16-.49.4-.01.04-.02.09-.02.13v.31ZM44.81 11.19c0 .11-.08.2-.21.2-.12 0-.2-.09-.2-.2s.09-.2.2-.2.2.09.2.2Zm-.37 2.3V11.7h.33v1.79zM46.52 14.16c-.08.06-.19.09-.3.09-.2 0-.33-.11-.33-.29s.15-.34.27-.43h-.1c-.54 0-.88-.37-.88-.9s.32-.97.84-.97c.59 0 .74.52.74.85 0 .07 0 .12-.01.15h-1.26c0 .44.29.62.62.62.23 0 .37-.04.5-.09l.06.23c-.06.03-.14.05-.17.06-.15.06-.35.24-.35.4 0 .11.07.16.15.16.05 0 .12-.02.17-.04l.05.17Zm-.07-1.74c0-.21-.09-.53-.45-.53-.33 0-.47.3-.5.53zM48.45 13.43c-.08.04-.27.1-.52.1-.54 0-.89-.37-.89-.92s.38-.95.96-.95c.19 0 .36.05.45.09l-.07.25a.81.81 0 0 0-.38-.09c-.41 0-.63.3-.63.68 0 .42.27.67.62.67.19 0 .31-.05.4-.09l.06.24ZM49.19 11.19c0 .11-.08.2-.21.2-.12 0-.2-.09-.2-.2s.09-.2.2-.2.2.09.2.2Zm-.36 2.3V11.7h.33v1.79zM49.88 12.65c0 .44.29.62.62.62.23 0 .38-.04.5-.09l.06.23c-.11.05-.31.11-.6.11-.55 0-.88-.36-.88-.9s.32-.97.84-.97c.59 0 .74.52.74.85 0 .07 0 .12-.01.15h-1.26Zm.96-.23c0-.21-.09-.53-.45-.53-.33 0-.47.3-.5.53zM52.36 10.99h.32v2.23h1.07v.27h-1.39zM54.7 11.39l-.42.23-.06-.25.53-.28h.28v2.41h-.32v-2.11ZM72.76 76.78c0-.18 0-.34-.01-.49h.29l.02.3c.09-.17.3-.34.59-.34.25 0 .63.15.63.76v1.07h-.33v-1.04c0-.29-.11-.53-.42-.53-.21 0-.38.15-.44.33a.68.68 0 0 0-.02.15v1.08h-.33v-1.31ZM75.81 78.08l-.03-.23h-.01c-.1.14-.29.27-.55.27-.36 0-.55-.26-.55-.52 0-.43.39-.67 1.08-.67v-.04c0-.15-.04-.42-.41-.42-.17 0-.34.05-.47.13l-.07-.21c.15-.1.36-.16.59-.16.55 0 .68.38.68.73v.67c0 .16 0 .31.03.43h-.3Zm-.05-.91c-.36 0-.76.06-.76.4 0 .21.14.31.31.31a.445.445 0 0 0 .45-.4zM76.6 76.88c0-.23 0-.42-.01-.59h.29v.31h.02c.13-.22.34-.35.64-.35.43 0 .76.37.76.91 0 .65-.39.96-.82.96-.24 0-.45-.1-.55-.28v.98h-.32v-1.94Zm.33.47s0 .09.01.13c.06.23.26.38.49.38.34 0 .54-.28.54-.69 0-.36-.19-.67-.53-.67-.22 0-.43.16-.49.4-.01.04-.02.09-.02.13v.31ZM79.08 75.79c0 .11-.08.2-.21.2-.12 0-.2-.09-.2-.2s.09-.2.2-.2.2.09.2.2Zm-.37 2.29v-1.79h.33v1.79zM80.79 78.76c-.08.06-.19.09-.3.09-.2 0-.33-.11-.33-.29s.15-.34.27-.43h-.1c-.54 0-.88-.37-.88-.91s.32-.97.84-.97c.59 0 .74.52.74.85 0 .07 0 .12-.01.15h-1.26c0 .44.29.62.62.62.23 0 .37-.04.5-.09l.06.23c-.06.03-.14.05-.17.06-.15.06-.35.25-.35.4 0 .11.07.16.15.16.05 0 .12-.01.17-.04zm-.07-1.75c0-.21-.09-.53-.45-.53-.33 0-.47.3-.5.53zM82.72 78.02c-.08.04-.27.1-.52.1-.54 0-.89-.37-.89-.92s.38-.95.96-.95c.19 0 .36.05.45.09l-.07.25a.828.828 0 0 0-.38-.08c-.41 0-.63.3-.63.68 0 .42.27.67.62.67.19 0 .31-.05.4-.09l.06.24ZM83.46 75.79c0 .11-.08.2-.21.2-.12 0-.2-.09-.2-.2s.09-.2.2-.2.2.09.2.2Zm-.36 2.29v-1.79h.33v1.79zM84.15 77.25c0 .44.29.62.62.62.23 0 .38-.04.5-.09l.06.23c-.11.05-.31.11-.6.11-.55 0-.88-.36-.88-.91s.32-.97.84-.97c.59 0 .74.52.74.85 0 .07 0 .12-.01.15h-1.26Zm.96-.24c0-.21-.09-.53-.45-.53-.33 0-.47.3-.5.53zM86.63 75.59h.32v2.23h1.07v.27h-1.39zM88.26 78.08v-.2l.26-.25c.62-.59.89-.9.9-1.26 0-.24-.12-.47-.48-.47-.22 0-.4.11-.51.2l-.1-.23c.17-.14.4-.25.68-.25.52 0 .74.36.74.7 0 .44-.32.8-.83 1.29l-.19.18h1.08v.27h-1.54ZM2.53 76.78c0-.18 0-.34-.01-.49h.29l.02.3c.09-.17.3-.34.59-.34.25 0 .63.15.63.76v1.07h-.33v-1.04c0-.29-.11-.53-.42-.53-.21 0-.38.15-.44.33a.68.68 0 0 0-.02.15v1.08h-.33v-1.31ZM5.58 78.08l-.03-.23h-.01c-.1.14-.29.27-.55.27-.36 0-.55-.26-.55-.52 0-.43.39-.67 1.08-.67v-.04c0-.15-.04-.42-.41-.42-.17 0-.34.05-.47.13l-.07-.21c.15-.1.36-.16.59-.16.55 0 .68.38.68.73v.67c0 .16 0 .31.03.43h-.3Zm-.05-.91c-.36 0-.76.06-.76.4 0 .21.14.31.31.31a.445.445 0 0 0 .45-.4zM6.38 76.88c0-.23 0-.42-.01-.59h.29v.31h.02c.13-.22.34-.35.64-.35.43 0 .76.37.76.91 0 .65-.39.96-.82.96-.24 0-.45-.1-.55-.28v.98h-.32v-1.94Zm.32.47s0 .09.01.13c.06.23.26.38.49.38.34 0 .54-.28.54-.69 0-.36-.19-.67-.53-.67-.22 0-.43.16-.49.4-.01.04-.02.09-.02.13v.31ZM8.85 75.79c0 .11-.08.2-.21.2-.12 0-.2-.09-.2-.2s.09-.2.2-.2.2.09.2.2Zm-.36 2.29v-1.79h.33v1.79zM10.56 78.76c-.08.06-.19.09-.3.09-.2 0-.33-.11-.33-.29s.15-.34.27-.43h-.1c-.54 0-.88-.37-.88-.91s.32-.97.84-.97c.59 0 .74.52.74.85 0 .07 0 .12-.01.15H9.53c0 .44.29.62.62.62.23 0 .37-.04.5-.09l.06.23c-.06.03-.14.05-.17.06-.15.06-.35.25-.35.4 0 .11.07.16.15.16.05 0 .12-.01.17-.04zm-.07-1.75c0-.21-.09-.53-.45-.53-.33 0-.47.3-.5.53zM12.49 78.02c-.08.04-.27.1-.52.1-.54 0-.89-.37-.89-.92s.38-.95.96-.95c.19 0 .36.05.45.09l-.07.25a.828.828 0 0 0-.38-.08c-.41 0-.63.3-.63.68 0 .42.27.67.62.67.19 0 .31-.05.4-.09l.06.24ZM13.24 75.79c0 .11-.08.2-.21.2-.12 0-.2-.09-.2-.2s.09-.2.2-.2.2.09.2.2Zm-.37 2.29v-1.79h.33v1.79zM13.92 77.25c0 .44.29.62.62.62.23 0 .38-.04.5-.09l.06.23c-.11.05-.31.11-.6.11-.55 0-.88-.36-.88-.91s.32-.97.84-.97c.59 0 .74.52.74.85 0 .07 0 .12-.01.15h-1.26Zm.96-.24c0-.21-.09-.53-.45-.53-.33 0-.47.3-.5.53zM16.4 75.59h.32v2.23h1.07v.27H16.4zM18.11 77.71c.09.06.31.15.53.15.42 0 .55-.27.54-.47 0-.34-.31-.48-.62-.48h-.18v-.25h.18c.24 0 .54-.12.54-.41 0-.19-.12-.36-.42-.36-.19 0-.38.08-.48.16l-.09-.24c.13-.09.37-.19.63-.19.47 0 .69.28.69.58 0 .25-.15.46-.45.57.3.07.54.29.54.63 0 .39-.3.72-.88.72-.27 0-.51-.09-.63-.16l.09-.25Z"
            style={{
              fill: '#25b75f',
              strokeWidth: 0,
            }}
          /> */}
        <text
          style={{
            fontSize: 3.5,
            fill:
              parseFloat(valueMet.A_PHA_VOLT_FL_1) >= MIN_VOLTAGE && parseFloat(valueMet.A_PHA_VOLT_FL_1) < MAX_VOLTAGE ? 'white' : 'red',
          }}
          x={39.5}
          y={13.5}>
          {`L1 - ${Math.trunc(parseFloat(valueMet.A_PHA_VOLT_FL_1))}V`}
        </text>
        <text
          style={{
            fontSize: 3.5,
            fill:
              parseFloat(valueMet.B_PHA_VOLT_FL_1) >= MIN_VOLTAGE && parseFloat(valueMet.B_PHA_VOLT_FL_1) < MAX_VOLTAGE ? 'white' : 'red',
          }}
          x={75}
          y={95}>
          {`L2 - ${Math.trunc(parseFloat(valueMet.B_PHA_VOLT_FL_1))}V`}
        </text>
        <text
          style={{
            fontSize: 3.5,
            fill:
              parseFloat(valueMet.C_PHA_VOLT_FL_1) >= MIN_VOLTAGE && parseFloat(valueMet.C_PHA_VOLT_FL_1) < MAX_VOLTAGE ? 'white' : 'red',
          }}
          x={2.5}
          y={95}>
          {`L3 - ${Math.trunc(parseFloat(valueMet.C_PHA_VOLT_FL_1))}V`}
        </text>
        <text
          style={{
            fontSize: 3.5,
            fill: '#25b75f',
          }}
          x={71}
          y={4}>
          {'max 253V'}
        </text>
        <text
          style={{
            fontSize: 3.5,
            fill: '#25b75f',
          }}
          x={71}
          y={21.6}>
          {'min 207V'}
        </text>
        {/* <Rect
            width={31.88}
            height={14.17}
            x={0.05}
            y={0.09}
            rx={1.42}
            ry={1.42}
            style={{
              fill: parseFloat(valueMet.A_PHA_VOLT_FL_1) >= 207 && parseFloat(valueMet.A_PHA_VOLT_FL_1) < 254 ? '#105a2e' : '#590000',
              opacity: 0.5,
              stroke: parseFloat(valueMet.A_PHA_VOLT_FL_1) >= 207 && parseFloat(valueMet.A_PHA_VOLT_FL_1) < 254 ? '#26bf64' : 'red',
              strokeMiterlimit: 10,
              strokeWidth: '.1px',
            }}
          /> */}
        {/* <Rect
            width={31.88}
            height={14.17}
            x={0.05}
            y={119.66}
            rx={1.42}
            ry={1.42}
            style={{
              fill: parseFloat(valueMet.C_PHA_VOLT_FL_1) >= 207 && parseFloat(valueMet.C_PHA_VOLT_FL_1) < 254 ? '#105a2e' : '#590000',
              opacity: 0.5,
              stroke: parseFloat(valueMet.C_PHA_VOLT_FL_1) >= 207 && parseFloat(valueMet.C_PHA_VOLT_FL_1) < 254 ? '#26bf64' : 'red',
              strokeMiterlimit: 10,
              strokeWidth: '.1px',
            }}
          /> */}
        {/* <Path
            d="M2.82 2.28h.4v3.01H4.7v.37H2.82V2.29ZM7.04 2.81l-.57.31-.08-.34.71-.38h.38v3.25h-.43V2.81ZM2.67 11.65v-.27l.35-.33c.83-.79 1.21-1.21 1.21-1.7 0-.33-.16-.63-.65-.63-.3 0-.54.15-.69.27l-.14-.31c.23-.19.55-.33.92-.33.7 0 1 .48 1 .95 0 .6-.44 1.09-1.12 1.75l-.26.24h1.46v.37H2.67ZM5.34 11.14c.13.08.42.21.72.21.57 0 .74-.36.74-.63 0-.46-.42-.65-.84-.65h-.25v-.33h.25c.32 0 .73-.17.73-.55 0-.26-.17-.49-.57-.49-.26 0-.51.12-.65.22l-.11-.32c.17-.12.5-.25.85-.25.64 0 .93.38.93.78 0 .33-.2.62-.6.77.4.09.73.39.73.85 0 .52-.41.98-1.19.98-.37 0-.69-.11-.85-.22l.12-.34ZM9.16 11.65v-.89H7.65v-.29L9.1 8.39h.48v2.02h.46v.35h-.46v.89zm0-1.23V9.33c0-.17 0-.34.02-.51h-.02c-.1.19-.18.33-.27.48l-.8 1.11h1.07ZM11.26 11.65l-1.1-3.37h.47l.53 1.66c.15.46.27.87.36 1.26.1-.39.24-.82.39-1.26l.57-1.67h.47l-1.21 3.37h-.48ZM15.27 11.65v-.27l.35-.33c.83-.79 1.21-1.21 1.21-1.7 0-.33-.16-.63-.65-.63-.3 0-.54.15-.69.27l-.14-.31c.23-.19.55-.33.92-.33.7 0 1 .48 1 .95 0 .6-.44 1.09-1.12 1.75l-.26.24h1.46v.37h-2.08ZM17.94 11.14c.13.08.42.21.72.21.57 0 .74-.36.74-.63 0-.46-.42-.65-.84-.65h-.25v-.33h.25c.32 0 .73-.17.73-.55 0-.26-.17-.49-.57-.49-.26 0-.51.12-.65.22l-.11-.32c.17-.12.5-.25.85-.25.64 0 .93.38.93.78 0 .33-.2.62-.6.77.4.09.73.39.73.85 0 .52-.41.98-1.19.98-.37 0-.69-.11-.85-.22l.12-.34ZM21.76 11.65v-.89h-1.51v-.29l1.45-2.08h.48v2.02h.46v.35h-.46v.89zm0-1.23V9.33c0-.17 0-.34.02-.51h-.02c-.1.19-.18.33-.27.48l-.8 1.11h1.07ZM22.97 11.65v-.27l.35-.33c.83-.79 1.21-1.21 1.21-1.7 0-.33-.16-.63-.65-.63-.3 0-.54.15-.69.27l-.14-.31c.23-.19.55-.33.92-.33.7 0 1 .48 1 .95 0 .6-.44 1.09-1.12 1.75l-.26.24h1.46v.37h-2.08ZM26.24 11.65l-.86-3.37h.46l.4 1.71c.1.42.19.84.25 1.17h.01c.06-.33.16-.74.27-1.17l.45-1.7h.46l.41 1.71c.1.4.19.8.24 1.16.07-.37.17-.75.27-1.17l.45-1.7h.45l-.96 3.37h-.46l-.43-1.76c-.1-.43-.18-.76-.22-1.1h-.01c-.06.33-.14.67-.26 1.1l-.48 1.76h-.46Z"
            style={{
              fill: parseFloat(valueMet.A_PHA_VOLT_FL_1) >= 207 && parseFloat(valueMet.A_PHA_VOLT_FL_1) < 254 ? 'red' : '#25b75f',
              strokeWidth: 0,
            }}
          /> */}
        {/* <Text
            style={{
              fontSize: 4.6,
              fill: parseFloat(valueMet.A_PHA_VOLT_FL_1) >= 207 && parseFloat(valueMet.A_PHA_VOLT_FL_1) < 254 ? '#25b75f' : 'red',
            }}
            x={2.5}
            y={5.7}
          >
            {'L1'}
          </Text>
          <Text
            style={{
              fontSize: 4.6,
              fill: parseFloat(valueMet.A_PHA_VOLT_FL_1) >= 207 && parseFloat(valueMet.A_PHA_VOLT_FL_1) < 254 ? '#25b75f' : 'red',
            }}
            x={2.5}
            y={11.5}
          >
            {`${Math.trunc(parseFloat(valueMet.A_PHA_VOLT_FL_1))}V`}
          </Text> */}
        {/* <Path
            d="M2.82 122h.44v3.01H4.7v.37H2.82v-3.37ZM6.19 124.87c.12.08.42.21.72.21.57 0 .74-.36.74-.63 0-.46-.42-.65-.84-.65h-.25v-.33h.25c.32 0 .73-.17.73-.55 0-.26-.17-.49-.57-.49-.26 0-.51.12-.65.22l-.12-.32c.17-.12.5-.25.85-.25.64 0 .93.38.93.78 0 .33-.2.62-.6.77.4.09.73.39.73.85 0 .52-.41.98-1.19.98-.37 0-.69-.12-.85-.22l.12-.34ZM2.67 131.37v-.27l.35-.33c.83-.79 1.21-1.21 1.21-1.7 0-.33-.16-.63-.65-.63-.3 0-.54.15-.69.27l-.14-.31c.23-.19.55-.33.92-.33.7 0 1 .48 1 .95 0 .6-.44 1.09-1.12 1.75l-.26.24h1.46v.37H2.67ZM5.34 130.87c.13.08.42.21.72.21.57 0 .74-.36.74-.63 0-.46-.42-.65-.84-.65h-.25v-.33h.25c.32 0 .73-.17.73-.55 0-.26-.17-.49-.57-.49-.26 0-.51.12-.65.22l-.11-.32c.17-.12.5-.25.85-.25.64 0 .93.38.93.78 0 .33-.2.62-.6.77.4.09.73.39.73.85 0 .52-.41.98-1.19.98-.37 0-.69-.11-.85-.22l.12-.34ZM9.16 131.37v-.89H7.65v-.29l1.45-2.08h.48v2.02h.46v.35h-.46v.89zm0-1.23v-1.09c0-.17 0-.34.02-.51h-.02c-.1.19-.18.33-.27.48l-.8 1.11h1.07ZM11.26 131.37l-1.1-3.37h.47l.53 1.66c.15.46.27.87.36 1.26.1-.39.24-.82.39-1.26l.57-1.67h.47l-1.21 3.37h-.48ZM15.27 131.37v-.27l.35-.33c.83-.79 1.21-1.21 1.21-1.7 0-.33-.16-.63-.65-.63-.3 0-.54.15-.69.27l-.14-.31c.23-.19.55-.33.92-.33.7 0 1 .48 1 .95 0 .6-.44 1.09-1.12 1.75l-.26.24h1.46v.37h-2.08ZM17.94 130.87c.13.08.42.21.72.21.57 0 .74-.36.74-.63 0-.46-.42-.65-.84-.65h-.25v-.33h.25c.32 0 .73-.17.73-.55 0-.26-.17-.49-.57-.49-.26 0-.51.12-.65.22l-.11-.32c.17-.12.5-.25.85-.25.64 0 .93.38.93.78 0 .33-.2.62-.6.77.4.09.73.39.73.85 0 .52-.41.98-1.19.98-.37 0-.69-.11-.85-.22l.12-.34ZM21.76 131.37v-.89h-1.51v-.29l1.45-2.08h.48v2.02h.46v.35h-.46v.89zm0-1.23v-1.09c0-.17 0-.34.02-.51h-.02c-.1.19-.18.33-.27.48l-.8 1.11h1.07ZM22.97 131.37v-.27l.35-.33c.83-.79 1.21-1.21 1.21-1.7 0-.33-.16-.63-.65-.63-.3 0-.54.15-.69.27l-.14-.31c.23-.19.55-.33.92-.33.7 0 1 .48 1 .95 0 .6-.44 1.09-1.12 1.75l-.26.24h1.46v.37h-2.08ZM26.24 131.37l-.86-3.37h.46l.4 1.71c.1.42.19.84.25 1.17h.01c.06-.33.16-.74.27-1.17l.45-1.7h.46l.41 1.71c.1.4.19.8.24 1.16.07-.37.17-.75.27-1.17l.45-1.7h.45l-.96 3.37h-.46l-.43-1.76c-.1-.43-.18-.76-.22-1.1h-.01c-.06.33-.14.67-.26 1.1l-.48 1.76h-.46Z"
            style={{
              fill: parseFloat(valueMet.C_PHA_VOLT_FL_1) >= 207 && parseFloat(valueMet.C_PHA_VOLT_FL_1) < 254 ? 'red' : '#25b75f',
              strokeWidth: 0,
            }}
          /> */}
        {/* <Text
            style={{
              fontSize: 4.6,
              fill: parseFloat(valueMet.C_PHA_VOLT_FL_1) >= 207 && parseFloat(valueMet.C_PHA_VOLT_FL_1) < 254 ? '#25b75f' : 'red',
            }}
            x={2.5}
            y={125.4}
          >
            {'L3'}
          </Text>
          <Text
            style={{
              fontSize: 4.6,
              fill: parseFloat(valueMet.C_PHA_VOLT_FL_1) >= 207 && parseFloat(valueMet.C_PHA_VOLT_FL_1) < 254 ? '#25b75f' : 'red',
            }}
            x={2.5}
            y={131.2}
          >
            {`${Math.trunc(parseFloat(valueMet.C_PHA_VOLT_FL_1))}V`}
          </Text> */}
        {/* <Rect
            width={31.88}
            height={14.17}
            x={63.29}
            y={119.66}
            rx={1.42}
            ry={1.42}
            style={{
              fill: parseFloat(valueMet.B_PHA_VOLT_FL_1) >= 207 && parseFloat(valueMet.B_PHA_VOLT_FL_1) < 254 ? '#105a2e' : '#590000',
              opacity: 0.5,
              stroke: parseFloat(valueMet.B_PHA_VOLT_FL_1) >= 207 && parseFloat(valueMet.B_PHA_VOLT_FL_1) < 254 ? '#26bf64' : 'red',
              strokeMiterlimit: 10,
              strokeWidth: '.1px',
            }}
          /> */}
        {/* <Path
            d="M66.06 122h.44v3.01h1.44v.37h-1.88v-3.37ZM69.33 125.37v-.27l.35-.33c.83-.79 1.21-1.21 1.21-1.7 0-.33-.16-.64-.65-.64-.29 0-.54.15-.69.28l-.14-.31c.23-.19.55-.33.92-.33.7 0 1 .48 1 .95 0 .6-.44 1.09-1.12 1.75l-.26.24h1.46v.37h-2.08ZM65.91 131.37v-.27l.35-.33c.83-.79 1.21-1.21 1.21-1.7 0-.33-.16-.63-.65-.63-.29 0-.54.15-.69.27l-.14-.31c.23-.19.55-.33.92-.33.7 0 1 .48 1 .95 0 .6-.44 1.09-1.12 1.75l-.26.24h1.46v.37h-2.08ZM68.58 130.87c.13.08.42.21.72.21.57 0 .74-.36.74-.63 0-.46-.42-.65-.84-.65h-.25v-.33h.25c.32 0 .73-.17.73-.55 0-.26-.17-.49-.57-.49-.26 0-.51.12-.65.22l-.11-.32c.17-.12.5-.25.85-.25.64 0 .93.38.93.78 0 .33-.2.62-.6.77.4.09.73.39.73.85 0 .52-.41.98-1.19.98-.37 0-.69-.11-.85-.22l.12-.34ZM72.4 131.37v-.89h-1.51v-.29l1.45-2.08h.48v2.02h.46v.35h-.46v.89zm0-1.23v-1.09c0-.17 0-.34.02-.51h-.02c-.1.19-.18.33-.27.48l-.8 1.11h1.07ZM74.5 131.37 73.4 128h.47l.53 1.66c.14.46.27.87.36 1.26.09-.39.24-.82.38-1.26l.57-1.67h.46l-1.21 3.37h-.48ZM78.51 131.37v-.27l.35-.33c.83-.79 1.21-1.21 1.21-1.7 0-.33-.16-.63-.65-.63-.29 0-.54.15-.69.27l-.14-.31c.23-.19.55-.33.92-.33.7 0 1 .48 1 .95 0 .6-.44 1.09-1.12 1.75l-.26.24h1.46v.37h-2.08ZM81.18 130.87c.13.08.42.21.72.21.57 0 .74-.36.74-.63 0-.46-.42-.65-.84-.65h-.25v-.33h.25c.32 0 .73-.17.73-.55 0-.26-.17-.49-.57-.49-.26 0-.51.12-.65.22l-.11-.32c.17-.12.5-.25.85-.25.64 0 .93.38.93.78 0 .33-.2.62-.6.77.4.09.73.39.73.85 0 .52-.41.98-1.19.98-.37 0-.69-.11-.85-.22l.12-.34ZM85.01 131.37v-.89H83.5v-.29l1.45-2.08h.48v2.02h.46v.35h-.46v.89zm0-1.23v-1.09c0-.17 0-.34.02-.51h-.02c-.1.19-.18.33-.27.48l-.8 1.11h1.07ZM86.21 131.37v-.27l.34-.33c.83-.79 1.21-1.21 1.21-1.7 0-.33-.16-.63-.65-.63-.3 0-.54.15-.69.27l-.14-.31c.22-.19.54-.33.92-.33.7 0 1 .48 1 .95 0 .6-.44 1.09-1.12 1.75l-.26.24h1.46v.37H86.2ZM89.48 131.37l-.86-3.37h.46l.4 1.71c.1.42.19.84.25 1.17h.01c.05-.33.16-.74.27-1.17l.45-1.7h.46l.41 1.71c.1.4.19.8.24 1.16.07-.37.17-.75.27-1.17l.45-1.7h.45l-.96 3.37h-.46l-.42-1.76c-.11-.43-.18-.76-.22-1.1-.06.33-.14.67-.26 1.1l-.48 1.76h-.46Z"
            style={{
              fill: parseFloat(valueMet.B_PHA_VOLT_FL_1) >= 207 && parseFloat(valueMet.B_PHA_VOLT_FL_1) < 254 ? 'red' : '#25b75f',
              strokeWidth: 0,
            }}
          /> */}
        {/* <Text
            style={{
              fontSize: 4.6,
              fill: parseFloat(valueMet.B_PHA_VOLT_FL_1) >= 207 && parseFloat(valueMet.B_PHA_VOLT_FL_1) < 254 ? '#25b75f' : 'red',
            }}
            x={65.8}
            y={125.4}
          >
            {'L2'}
          </Text>
          <Text
            style={{
              fontSize: 4.6,
              fill: parseFloat(valueMet.B_PHA_VOLT_FL_1) >= 207 && parseFloat(valueMet.B_PHA_VOLT_FL_1) < 254 ? '#25b75f' : 'red',
            }}
            x={65.8}
            y={131.2}
          >
            {`${Math.trunc(parseFloat(valueMet.B_PHA_VOLT_FL_1))}V`}
          </Text> */}
        {/* <Path
            d="M76.3 20.08c0-.19 0-.34-.01-.49h.29l.02.29h.01c.1-.17.27-.33.56-.33.25 0 .43.15.51.36.06-.1.13-.18.2-.23.11-.08.23-.13.4-.13.24 0 .59.16.59.78v1.06h-.32v-1.02c0-.34-.13-.55-.39-.55-.19 0-.33.14-.39.3-.01.04-.03.1-.03.16v1.11h-.32v-1.08c0-.29-.13-.49-.38-.49-.2 0-.35.16-.4.33-.02.05-.03.1-.03.16v1.08h-.32v-1.31ZM79.76 19.09c0 .11-.08.2-.21.2-.12 0-.2-.09-.2-.2s.09-.2.2-.2.2.09.2.2Zm-.37 2.3V19.6h.33v1.79zM80.26 20.08c0-.19 0-.34-.01-.49h.29l.02.3c.09-.17.3-.34.59-.34.25 0 .63.15.63.76v1.07h-.33v-1.03c0-.29-.11-.53-.42-.53-.21 0-.38.15-.44.33a.68.68 0 0 0-.02.15v1.08h-.33v-1.31ZM83 21.39v-.2l.26-.25c.62-.59.89-.9.9-1.26 0-.24-.12-.47-.48-.47-.22 0-.4.11-.51.2l-.1-.23c.17-.14.4-.24.68-.24.52 0 .74.36.74.7 0 .44-.32.8-.83 1.29l-.19.18h1.08v.27h-1.54ZM86.51 20.16c0 .82-.3 1.27-.84 1.27-.47 0-.79-.44-.8-1.24 0-.81.35-1.25.84-1.25s.8.45.8 1.22m-1.31.04c0 .63.19.98.49.98.33 0 .49-.39.49-1s-.15-.98-.49-.98c-.29 0-.49.35-.49 1M88.37 18.98v.21l-1.05 2.2h-.34l1.05-2.13h-1.18v-.27h1.52ZM90.03 21.39l-.82-2.5h.35l.39 1.23c.11.34.2.64.27.93.07-.29.17-.6.29-.93l.42-1.23h.34l-.89 2.5h-.36Z"
            style={{
              fill: '#25b75f',
              strokeWidth: 0,
            }}
          /> */}
        {/* <Path
            d="m46.18 30.79.17-.18"
            style={{
              fill: 'none',
              stroke: '#16703a',
              strokeMiterlimit: 10,
              strokeWidth: '.2px',
            }}
          /> */}
        <path
          d="M46.7 30.25 67.7 3.34"
          style={{
            fill: 'none',
            stroke: '#16703a',
            strokeDasharray: '0 0 .5 .5',
            strokeMiterlimit: 10,
            strokeWidth: '.8px',
          }}
        />
        {/* <Path
            d="m72.92 3.16.17-.18M15.99 14.27l30.19 19.99"
            style={{
              fill: 'none',
              stroke: '#16703a',
              strokeMiterlimit: 10,
              strokeWidth: '.2px',
            }}
          /> */}
        {/* <Path
            d="m15.99 119.66-3.13-35.01M79.23 119.37 58.57 72.95"
            style={{
              fill: 'none',
              opacity: 0.5,
              stroke: 'red',
              strokeMiterlimit: 10,
              strokeWidth: '.2px',
            }}
          /> */}
        <path
          d="m46.18 48.13.17-.18"
          style={{
            fill: 'none',
            stroke: '#16703a',
            strokeMiterlimit: 10,
            strokeWidth: '.4px',
          }}
        />
        <path
          d="M46.6 48 67.7 20.5"
          style={{
            fill: 'none',
            stroke: '#16703a',
            strokeDasharray: '0 0 .5 .5',
            strokeMiterlimit: 10,
            strokeWidth: '.8px',
          }}
        />
        <path
          d="m72.92 20.5.17-.18"
          style={{
            fill: 'none',
            stroke: '#16703a',
            strokeMiterlimit: 10,
            strokeWidth: '.4px',
          }}
        />
        <path
          d="M46.18 18.18h-1.4l.7-1.22.7-1.21.7 1.21.7 1.22zM87.69 89.4l.7-1.21.7 1.21.7 1.22h-2.8zM3.95 90.62h-1.4l.7-1.22.7-1.21.7 1.21.7 1.22z"
          style={{
            fill: '#16703a',
            strokeWidth: 0,
          }}
        />
        <g data-name="napiecie L1 kropka">
          <circle
            cx={x1}
            cy={y1}
            r={1.11}
            data-name="napiecie L1"
            style={{
              fill:
                parseFloat(valueMet.A_PHA_VOLT_FL_1) >= MIN_VOLTAGE && parseFloat(valueMet.A_PHA_VOLT_FL_1) < MAX_VOLTAGE
                  ? 'white'
                  : 'red',
              strokeWidth: 0,
            }}
          />
        </g>
        <text
          style={{
            fontSize: 3.5,
            fill: 'white',
          }}
          transform={`translate(${middle1_3.x}, ${middle1_3.y
            }) rotate(${pivot1_3}) translate(${-middle1_3.x - 3.5}, ${-middle1_3.y - 1
            })`}
          x={middle1_3.x}
          y={middle1_3.y}>
          {`${Math.trunc(parseFloat(valueMet.CA_LINE_VOLT_FL_1))}V`}
        </text>
        <text
          style={{
            fontSize: 3.5,
            fill: 'white',
          }}
          transform={`translate(${middle3_2.x}, ${middle3_2.y
            }) rotate(${pivot3_2}) translate(${-middle3_2.x - 3.5}, ${-middle3_2.y + 3.8
            })`}
          x={middle3_2.x}
          y={middle3_2.y}>
          {`${Math.trunc(parseFloat(valueMet.BC_LINE_VOLT_FL_1))}V`}
        </text>
        <text
          style={{
            fontSize: 3.5,
            fill: 'white',
          }}
          transform={`translate(${middle2_1.x}, ${middle2_1.y
            }) rotate(${pivot2_1}) translate(${-middle2_1.x - 3.5}, ${-middle2_1.y - 1
            })`}
          x={middle2_1.x}
          y={middle2_1.y}>
          {`${Math.trunc(parseFloat(valueMet.AB_LINE_VOLT_FL_1))}V`}
        </text>

      </svg> : null}
    </React.Fragment>
  )
}

export default MeterDiagram